import styled from '@emotion/styled';
import Grid from '@mui/material/Grid';
import { css } from '@mui/material';
import { colors } from 'theme/colors';

interface IStyledGridTab {
  selected: boolean;
}

export const StyledGridTab = styled(Grid)<IStyledGridTab>`
  flex: 1;
  background-color: ${colors.white};
  border: 1px solid ${colors.white};
  justify-content: center;
  padding: 8px 12px;
  box-shadow: 0 2px 4px rgba(194, 204, 243, 0.35), 0 2px 6px rgba(194, 204, 243, 0.3),
    0 4px 8px rgba(194, 204, 243, 0.2), 0 6px 10px rgba(194, 204, 243, 0.2);
  border-radius: 4px;
  cursor: pointer;

  & > span {
    color: ${colors.blue200};
  }

  & > h6 {
    color: ${colors.blue600};
  }

  &:hover {
    opacity: 0.7;
    box-shadow: none;
  }

  ${({ selected }: IStyledGridTab) => css`
    ${`border-color: ${selected ? `${colors.blue600}` : `${colors.white}`}`};
    ${`color: ${selected ? colors.white : colors.primary500}`};

    & > span {
      color: ${selected ? colors.blue600 : colors.blue200};
    }

    & > h6 {
      font-family: ${selected
        ? 'NotoSansSemiBold, sans-serif'
        : 'NotoSansRegular, sans-serif'};
    }
  `};
`;
